import React, { useEffect, useState } from 'react'
import ProjectDetail from '../ProjectDetail/ProjectDetail';
import Loader from './../../component/Spinner/Loader';
import useTitle from './../../hooks/UseTitle';


// fetch('https://server-mu-six.vercel.app/projects')
function Project() {
  useTitle('Portfolio')
  const [projects,setProjects]=useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch('https://server-mu-six.vercel.app/projects')
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setProjects(data);
      });
  }, []);

  if (loading) {
    return <Loader></Loader>;
  }

  return (
    <div className='min-h-screen max-w-screen-xl mx-auto'>
       <h2 className="font-bold text-6xl  md:text-[120px] text-gray-300 opacity-[0.3] text-center animate-pulse numb">PORTFOLIO</h2>
       <div className="text-center absolute md:top-[3%] lg:top-[8%] top-[2%] md:left-[37%] lg:left-[42%] left-[28%]">
       <h2 data-aos="fade-up" className=" font-bold text-xl md:text-4xl text-neutral ">MY RECENT WORKS</h2>
       </div>

      <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 md:gap-5 px-3 my-8'>
          {
            projects?.map(project=><ProjectDetail key={project.id} project={project}>

            </ProjectDetail>)
          }
      </div>
    </div>
  )
}

export default Project
